export function applyRootStyles() {
  const body = document.querySelector('body') as HTMLBodyElement;
  body.style.overflow = 'hidden';
  body.style.pointerEvents = 'none';
}

export function cleanupRootStyles() {
  const body = document.querySelector('body') as HTMLBodyElement;

  body.style.removeProperty('overflow');

  setTimeout(() => {
    body.style.removeProperty('pointer-events');
  }, 0);
}
